export const brand = {
  name: 'Kit Attività Ottobre Rosa 3-in-1',
  short: 'KIT ATTIVITÀ OTTOBRE ROSA',
  tag: 'Una soluzione pronta all’uso per le tue iniziative di Ottobre Rosa',
}

export const checkoutUrl = 'https://octobrerose.impultienda.ar'

export const mockups = {
  kit: 'https://cdn.magicpatterns.com/uploads/98igWw2vHyhKCLt696D4at/mockup-it.png',
  cards: 'https://cdn.magicpatterns.com/uploads/hGAaFygb4hjsVepq8aV1nb/prod-1it.png',
  guide: 'https://cdn.magicpatterns.com/uploads/8rEobgFszNErNxNQopoB6G/prod3.png',
  bookmarks: 'https://cdn.magicpatterns.com/uploads/3xmWhWV27A26aPUzFvdetU/prod-2it.png',
}

/* Contenuto del kit (prima riga sotto l’hero) */
export const heroContents: string[] = ['50 carte', '150 segnalibri', 'Guida di 50 pagine', '3 bonus']

/* Badge pratici (seconda riga sotto l’hero) */
export const heroFacts: string[] = ['Accesso immediato', 'Pronto da stampare', 'Kit 3-in-1', 'Accesso a vita']

/* ---------- PREZZO (modifica solo qui) ---------- */
export const offer = {
  listPrice: '39\u00A0€',
  price: '19',
  currency: '€',
  /* Valori inviati al pixel Meta al clic sulla CTA */
  pixelValue: 19,
  currencyCode: 'EUR',
  subtitle: 'Offerta di lancio · Accesso a vita',
  detail:
    'Il Kit completo, del valore di 39\u00A0€, include 50 Carte di Riflessione, 150 Segnalibri Ispirazionali e una Guida Pratica alle Attività di 50 pagine. In più ricevi 3 Bonus del valore complessivo di 39\u00A0€ e supporto via e-mail. Valore totale: 78\u00A0€. Oggi: solo 19\u00A0€.',
  cta: 'Voglio il mio Kit Ottobre Rosa',
}

export const bonusTotal = '39\u00A0€'

export interface UseCase {
  icon: 'association' | 'hr' | 'training'
  role: string
  city: string
  description: string
}

export const useCases: UseCase[] = [
  {
    icon: 'association',
    role: 'Referente di un’associazione',
    city: 'Milano',
    description:
      'Devi preparare un’attività di 60 minuti? Il format, le Carte di Riflessione e i materiali ti permettono di organizzare rapidamente un’esperienza chiara e partecipativa, senza dover partire da zero.',
  },
  {
    icon: 'hr',
    role: 'Responsabile HR',
    city: 'Roma',
    description:
      'Per un’iniziativa Ottobre Rosa in azienda, le Carte di Riflessione aiutano a creare un momento partecipativo, mentre i Segnalibri permettono a ogni persona di portare con sé un piccolo messaggio.',
  },
  {
    icon: 'training',
    role: 'Formatrice',
    city: 'Bologna',
    description:
      '30, 60 o 90 minuti? Scegli il format più adatto e adatta le attività al tempo disponibile, al numero di partecipanti e al contesto.',
  },
]

export interface ProductImage {
  src: string
  alt: string
}

export interface Product {
  eyebrow: string
  title: string
  lead: string
  body: string
  points?: string[]
  kicker: string
  images: ProductImage[]
}

export const products: Product[] = [
  {
    eyebrow: 'Prodotto 1',
    title: '50 Carte di Riflessione',
    lead: '50 carte pronte da stampare, pensate per stimolare la riflessione, aprire il dialogo e facilitare la condivisione.',
    body: 'Puoi utilizzarle per introdurre un’attività, accompagnare un workshop oppure creare un piccolo momento di pausa e riflessione. Sono adatte ad associazioni, aziende, gruppi, contesti formativi e iniziative locali. Ricevi i file in PDF ad alta qualità, pronti da stampare.',
    kicker: 'Domande semplici che possono aprire conversazioni autentiche.',
    images: [
      {
        src: mockups.cards,
        alt: 'Tablet con il PDF delle Carte di Riflessione Ottobre Rosa: nove carte con domande pensate per stimolare il dialogo',
      },
    ],
  },
  {
    eyebrow: 'Prodotto 2',
    title: '150 Segnalibri Ispirazionali',
    lead: '150 segnalibri diversi, pronti da stampare e ritagliare, per lasciare a ogni partecipante un piccolo messaggio da portare con sé anche dopo l’iniziativa.',
    body: 'Cura di sé, prevenzione, solidarietà, sostegno e benessere. Puoi distribuirli alla fine dell’attività, lasciarli sui tavoli, integrarli in una dinamica oppure utilizzarli in uno spazio dedicato alla sensibilizzazione. Un piccolo ricordo di Ottobre Rosa.',
    kicker: 'Un messaggio da portare con sé. Un gesto che resta.',
    images: [
      {
        src: mockups.bookmarks,
        alt: 'Mano che tiene tre Segnalibri Ispirazionali Ottobre Rosa decorati con nastro rosa, fiori e illustrazioni femminili',
      },
    ],
  },
  {
    eyebrow: 'Prodotto 3',
    title: 'Guida Pratica alle Attività — 50 pagine',
    lead: 'Una guida pratica per organizzare e gestire la tua iniziativa Ottobre Rosa senza dover creare tutto da zero.',
    body: '',
    points: [
      '35 attività e format pronti all’uso',
      'Format da 30, 60 e 90 minuti',
      'Utilizzo delle Carte di Riflessione e dei Segnalibri Ispirazionali',
      'Attività individuali, in coppia, in cerchio e in piccoli o grandi gruppi',
      'Indicazioni per apertura e chiusura',
      'Preparazione dello spazio, checklist e gestione del tempo',
      'Suggerimenti per facilitare la partecipazione e adattare le attività al gruppo',
      'Indicazioni per gestire con rispetto eventuali momenti di maggiore emotività',
      'Schede pratiche da stampare',
      'Checklist e format già strutturati',
    ],
    kicker: 'Tutto è già organizzato. Devi solo scegliere l’attività e metterla in pratica.',
    images: [
      {
        src: mockups.guide,
        alt: 'Guida Pratica alle Attività Ottobre Rosa di 50 pagine: copertina, schede operative, format da 30, 60 e 90 minuti, checklist e attività pronte all’uso',
      },
    ],
  },
]

export const deliverables: string[] = [
  '50 Carte di Riflessione pronte da stampare',
  '150 Segnalibri Ispirazionali pronti da stampare e ritagliare',
  'Guida Pratica alle Attività Ottobre Rosa di 50 pagine',
  '35 attività e dinamiche pronte all’uso',
  'Format già strutturati da 30, 60 e 90 minuti',
  'Indicazioni per apertura e chiusura',
  'Checklist di preparazione',
  'Schede pratiche stampabili',
  'File PDF ad alta qualità',
  'Accesso immediato dopo l’acquisto',
  'Accesso a vita',
  'Supporto via e-mail',
]

export const deliverablesExtra = '+ 3 Bonus inclusi'

export interface Bonus {
  tag: string
  title: string
  subtitle: string
  lead: string
  promise: string
  includes: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus 1',
    title: 'Guida al Supporto Emotivo',
    subtitle: 'Trovare le parole giuste quando emerge un momento di emozione',
    lead: 'Una guida pratica per sapere come reagire con sensibilità quando una persona si emoziona o condivide un’esperienza personale difficile.',
    promise: 'Indicazioni concrete per facilitare l’attività con maggiore serenità e rispetto.',
    includes: [
      'Principi essenziali',
      'Frasi semplici e rispettose',
      'Cosa è meglio evitare di dire',
      'Ascoltare senza invadere',
      'Quando proporre una pausa',
      'Quando suggerire il supporto di un professionista competente',
    ],
    value: '15\u00A0€',
  },
  {
    tag: 'Bonus 2',
    title: 'Ottobre Rosa: Miti e Verità',
    subtitle: 'Sensibilizzare con informazioni chiare e responsabili',
    lead: 'Una risorsa pratica per parlare di Ottobre Rosa in modo accessibile e rispettoso, evitando allarmismi e informazioni poco affidabili. I contenuti sono di carattere generale e non sostituiscono le indicazioni ufficiali né il parere di un professionista sanitario.',
    promise: 'Per parlare di prevenzione con maggiore chiarezza.',
    includes: [
      'Comprendere il significato di Ottobre Rosa',
      'Miti e verità',
      'Comunicare senza creare paura',
      'Domande frequenti',
      'Buone pratiche di sensibilizzazione',
      'Un linguaggio chiaro e rispettoso',
    ],
    value: '12\u00A0€',
  },
  {
    tag: 'Bonus 3',
    title: 'Planner Express — Organizza la tua iniziativa Ottobre Rosa in 48 ore',
    subtitle: 'Dall’idea a un’attività pronta ad accogliere il tuo pubblico',
    lead: 'Una guida operativa semplice per organizzare la tua iniziativa Ottobre Rosa anche quando hai poco tempo.',
    promise: 'Una struttura chiara per preparare tutto senza disperderti tra mille cose.',
    includes: [
      'Metodo in 4 fasi',
      'Piano operativo di 48 ore',
      'Format da 30 / 60 / 90 minuti',
      'Checklist dei materiali',
      'Preparazione dello spazio',
      'Apertura, attività e chiusura',
      'Adattamenti in base al contesto',
    ],
    value: '12\u00A0€',
  },
]

export const trustItems = [
  { icon: 'lock', label: 'Pagamento sicuro' },
  { icon: 'check', label: 'Accesso immediato' },
  { icon: 'money', label: 'Garanzia di 7 giorni' },
  { icon: 'mail', label: 'Supporto via e-mail' },
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Come riceverò i file?',
    answer:
      'Dopo la conferma del pagamento riceverai i file digitali via e-mail. Potrai scaricarli e conservarli sul tuo computer, tablet o smartphone.',
  },
  {
    question: 'I file sono pronti da stampare?',
    answer:
      'Sì. Tutti i materiali sono forniti in formato PDF ad alta qualità e sono stati pensati per essere stampati facilmente. Puoi anche consultarli direttamente da computer, tablet o smartphone.',
  },
  {
    question: 'Posso utilizzare il Kit per più iniziative?',
    answer:
      'Sì. Dopo l’acquisto hai accesso a vita ai materiali e puoi riutilizzarli per le tue iniziative, adattandoli ogni volta al contesto e al gruppo.',
  },
  {
    question: 'Devo essere psicologa o professionista sanitaria per utilizzare il Kit?',
    answer:
      'No. Il Kit è stato pensato come strumento di sensibilizzazione e facilitazione. Le attività non richiedono competenze cliniche e non hanno finalità mediche o terapeutiche.',
  },
  {
    question: 'Cosa succede se una partecipante si emoziona molto?',
    answer:
      'Nel Kit trovi anche la Guida al Supporto Emotivo, con indicazioni pratiche per ascoltare con rispetto, evitare frasi poco appropriate e capire quando può essere utile suggerire il supporto di un professionista competente.',
  },
  {
    question: 'Posso utilizzare il Kit in azienda, in associazione o in altri contesti?',
    answer:
      'Sì. Le attività sono pensate per essere adattate a contesti diversi: aziende, associazioni, gruppi, contesti formativi, iniziative locali e altri spazi dedicati alla sensibilizzazione.',
  },
]
